import { type JSX } from 'react';

import { Datepicker } from '@/ui';

interface DateFieldProps {
  id: string;
  label: string | JSX.Element;
  value: string | null | undefined;
  onChange: (value: string | null) => void;
  error?: string;
  disabled?: boolean;
  description?: string;
}

const DateField = ({
  id,
  label,
  value,
  onChange,
  error,
  disabled,
  description
}: DateFieldProps) => (
  <div className="flex flex-col gap-1">
    <Datepicker
      name={id}
      label={label}
      value={value ?? null}
      onChange={onChange}
      disabled={disabled}
    />
    {description && (
      <p className="text-xs text-uniform-gray-600 dark:text-uniform-gray-400">{description}</p>
    )}
    {error && <p className="text-sm text-red-500 dark:text-red-400">{error}</p>}
  </div>
);

export default DateField;
